import { registerAdditionalPayment } from '../../services/ProfessionalSettlementController';
import { ProfessionalSettlementDTO } from '../../dto/ProfessionalSettlementDTO';
import ReadonlyField from '../../components/ReadonlyField/ReadonlyField';
import ProfessionalPaymentDialog from '../../components/ProfessionalPaymentDialog/ProfessionalPaymentDialog';
import { formatMoney } from '../../utils/money';

interface AdditionalPaymentDialogProps {
    /** Cierre al que se le registra el pago. `null` cierra el diálogo. */
    settlement: ProfessionalSettlementDTO | null;
    onHide: () => void;
    onRegistered: () => void;
}

/** Pago adicional sobre el saldo pendiente de un cierre de rendición. */
export default function AdditionalPaymentDialog({ settlement, onHide, onRegistered }: AdditionalPaymentDialogProps) {
    return (
        <ProfessionalPaymentDialog
            visible={settlement != null}
            header="Registrar pago adicional"
            pendingAmount={settlement?.pendingamount ?? 0}
            summary={settlement && (
                <>
                    <ReadonlyField label="Cierre">N° {settlement.closingnumber}</ReadonlyField>
                    <ReadonlyField label="Profesional">{settlement.professionalname}</ReadonlyField>
                    <ReadonlyField label="Saldo pendiente">{formatMoney(settlement.pendingamount)}</ReadonlyField>
                </>
            )}
            onSubmit={payment => registerAdditionalPayment({
                professionalSettlementId: settlement!.professionalsettlement,
                paymentAmount: payment.amount,
                paymentMethodId: payment.paymentMethodId,
                locationCashRegisterId: payment.locationCashRegisterId,
                financialAccountId: payment.financialAccountId,
            })}
            onHide={onHide}
            onRegistered={onRegistered}
        />
    );
}
